module.exports = __webpack_public_path__ + "res/img/icon-ppt.db5508d6.png";